import ReactDOM from "react-dom";
import React from "react";
import {Provider} from 'react-redux';
import { renderComponent, renderBreakingNews } from '@quintype/framework/client/start';
import { BreakingNewsView } from '../isomorphic/components/breaking-news/breaking-news-view';
import { pickComponent } from '../isomorphic/pick-component';
import { Metype } from "../isomorphic/components/metype.js";
import { Footer } from '../isomorphic/components/footer.js';
import { LoadingIndicatorComponent } from "../isomorphic/components/basic/loading-indicator.js";
import { pickHeader } from '../isomorphic/pick-header';
import {InjectWidget} from "../isomorphic/components/inject-widget";
import {CLIENT_SIDE_RENDERED} from "@quintype/components/store/actions";
import {IsomorphicComponent} from "@quintype/framework/isomorphic/component";


export function renderIsomorphicComponent(container, store, pickComponent, props) {
  if(!store.getState().qt.disableIsomorphicComponent) {
    return ReactDOM.hydrate(
      React.createElement(Provider, {store: store},
        React.createElement(IsomorphicComponent, Object.assign({pickComponent}, props))),
      document.getElementById(container),
      () => store.dispatch({type: CLIENT_SIDE_RENDERED}));
  }
}

export function preRenderApplication(store) {
  const themeAttributes = store.getState().qt.config["theme-attributes"];
  const headerTheme = themeAttributes["header_theme"] || 'navigation-default';

  pickHeader(headerTheme)
    .then(header => renderComponent(header.default, 'navbar', store));

  if(!themeAttributes.hide_breaking_news)
    renderBreakingNews('breaking-news-container', store, BreakingNewsView);

  renderComponent(InjectWidget, 'widget', store);
  renderComponent(Metype, 'meType', store);
  renderComponent(Footer, 'footer', store);
}

// This is a separate file as everything from here on is hot reloaded when the app changes
export function renderApplication(store) {
  if(global.location.hash === "#secret-mode") {
    import(/* webpackChunkName: "secret-mode" */ './secret-mode').then(({startSecretMode}) => startSecretMode(store));
  }
  renderIsomorphicComponent("container", store, pickComponent, {hydrate: !global.qtLoadedFromShell});
  renderBreakingNews("breaking-news-container", store, BreakingNewsView);
  renderComponent(LoadingIndicatorComponent, 'loading-indicator', store);
}
